import { __assign } from "tslib";
import { makeStyles, shorthands, tokens } from '@fluentui/react-components';
import { CardFooterHeight, CardHeaderHeight, CardHeight, CardPreviewHeight, FileCardPreviewHeight, InnerDivHeight, MeetingAndTaskInfoHeight, } from './StyleConstants';
export var useCardStyles = makeStyles({
    root: __assign({ height: CardHeight, 
        //Display actions button
        ':hover .show': {
            opacity: 1,
        }, ':focus .show': {
            opacity: 1,
        }, ':focus-within .show': {
            opacity: 1,
        } }, shorthands.margin('2px', '2px', '2px', '2px')),
    fileRoot: {
        rowGap: '8px',
    },
    helperText: { display: 'none' },
    meetingAndTaskHeader: __assign({ height: CardHeaderHeight }, shorthands.margin('0px', '0px', '4px')),
    header: {
        // First child is icon
        '> :first-child': {
            minWidth: '30px',
        },
        // 2nd child is content
        '> :nth-child(2)': {
            minWidth: 0,
        },
    },
    actionsButtonDisplay: {
        opacity: 0,
        '& .fui-Icon-regular, .fui-Icon-filled': {
            height: '20px',
            width: '20px',
            marginRight: '-10px', //TODO: add rtl/ltr check for this margin
        },
    },
    meetingHeaderTitle: {
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightSemibold,
    },
    avatar: {
        width: '32px',
    },
    headerDescription: {
        color: tokens.colorNeutralForeground3,
    },
    fileInnerDiv: __assign(__assign(__assign(__assign({ height: InnerDivHeight }, shorthands.margin('0px', '-4px', '-4px')), shorthands.border('1px', 'solid', tokens.colorNeutralStroke2)), shorthands.borderRadius(tokens.borderRadiusMedium)), shorthands.padding('4px')),
    meetingAndTaskInnerDiv: __assign({ display: 'flex' }, shorthands.gap('8px')),
    fileHeaderTitle: {
        color: tokens.colorNeutralForeground1,
    },
    secondHeadingBase: __assign(__assign({ display: 'flex', flexDirection: 'row', fontWeight: tokens.fontWeightSemibold }, shorthands.gap('6px')), shorthands.margin('6px', '4px', '10px', '4px')),
    fileSecondHeading: {
        '> div': {
            marginBottom: '-8.5px',
            '> i > img': {
                verticalAlign: 'baseline', //TODO: change DocumentIcon to accept styling
            },
        },
    },
    compositeTimeLine: {
        display: 'flex',
        flexDirection: 'row',
    },
    compositeStartsInDark: {
        color: '#AAB1FA',
        fontWeight: tokens.fontWeightSemibold,
    },
    compositeStartsInLight: {
        color: '#383966',
        fontWeight: tokens.fontWeightSemibold,
    },
    title: {
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightSemibold,
    },
    fileImageContainer: __assign(__assign({ position: 'relative' }, shorthands.overflow('hidden')), shorthands.borderRadius(tokens.borderRadiusMedium)),
    fileImageThumbnail: {
        objectFit: 'cover',
        objectPosition: 'center top',
        opacity: '0.93',
        width: '100%',
        height: '100%',
        position: 'relative',
    },
    overlay: {
        opacity: '0.02',
        backgroundColor: 'black',
        zIndex: '1',
        position: 'absolute',
        width: '100%',
        height: '100%',
        top: '0',
    },
    mediaDuration: __assign(__assign(__assign(__assign({ position: 'absolute', display: 'flex', zIndex: '2', justifyContent: 'center' }, shorthands.padding('2px', '4px')), shorthands.margin('8px')), shorthands.borderRadius(tokens.borderRadiusMedium)), { backgroundColor: 'rgba(0, 0, 0, 0.58)', color: 'white', bottom: '0', right: '0' }),
    fileImageErrorThumbnail: __assign({ alignItems: 'center', justifyContent: 'center', backgroundColor: tokens.colorNeutralBackground4 }, shorthands.borderRadius(tokens.borderRadiusMedium)),
    filePreview: {
        height: FileCardPreviewHeight,
        display: 'flex',
        cursor: 'pointer',
    },
    meetingAndTaskPreview: __assign(__assign(__assign(__assign({ height: CardPreviewHeight, display: 'flex', boxSizing: 'border-box' }, shorthands.margin('0px', '-4px !important')), shorthands.border('1px', 'solid', tokens.colorNeutralStroke2)), shorthands.borderRadius(tokens.borderRadiusMedium)), shorthands.padding('4px')),
    meetingAndTaskInfo: __assign(__assign({ display: 'flex', flexDirection: 'column', boxSizing: 'border-box', height: MeetingAndTaskInfoHeight }, shorthands.borderRadius(tokens.borderRadiusMedium)), { cursor: 'pointer' }),
    suggestedTaskInfo: __assign(__assign({}, shorthands.gap('4px')), shorthands.padding('16px', '24px')),
    suggestedTaskInfoDark: {
        backgroundColor: '#082338',
        ':hover': { backgroundColor: '#0C3B5E' },
        ':active': { backgroundColor: '#061724' }, //hardcoded Brand Comm 10
    },
    suggestedTaskInfoLight: {
        backgroundColor: '#EBF3FC',
        ':hover': { backgroundColor: '#CFE4FA' },
        ':active': { backgroundColor: '#96C6FA' }, //hardcoded Brand Comm 130
    },
    meetingInfo: __assign(__assign(__assign({ justifyContent: 'space-between' }, shorthands.gap('8px')), shorthands.padding('12px', '22px', '8px')), shorthands.borderLeft('4px', 'solid', '#5B5FC7')),
    meetingInfoDark: {
        backgroundColor: '#2F2F4A',
        ':hover': { backgroundColor: '#383966' },
        ':active': { backgroundColor: '#2B2B40' }, //hardcoded Teams Brand 10 token color
    },
    meetingInfoLight: {
        backgroundColor: '#E8EBFA',
        ':hover': { backgroundColor: '#DCDFFA' },
        ':active': { backgroundColor: '#B6BCFA' }, //hardcoded Teams Brand 130 token color
    },
    meetingLocationLine: __assign(__assign({ display: 'flex' }, shorthands.gap('4px')), { alignItems: 'center' }),
    rowGap: __assign({}, shorthands.gap('4px')),
    avatarGroup: __assign({ marginTop: '4px', marginLeft: '-6px', '> :nth-child(n)': {
            marginLeft: '6px !important',
        }, '> button': {
            color: tokens.colorNeutralBackgroundInverted,
        } }, shorthands.overflow('hidden')),
    avatarGroupLightMode: {
        '> button': __assign({ backgroundColor: '#C5CBFA' }, shorthands.borderColor('#C5CBFA')),
    },
    avatarGroupDarkMode: {
        '> button': __assign({ backgroundColor: '#3D3E78' }, shorthands.borderColor('#3D3E78')),
    },
    meetingContent: __assign({ display: 'flex', flexDirection: 'column' }, shorthands.gap('4px')),
    meetingInsights: __assign({}, shorthands.gap('4px')),
    meetingInsightsIcon: {
        flexShrink: '0',
        '> img': {
            verticalAlign: 'baseline', //TODO: change FontIcon to accept styling
        },
    },
    meetingInsightsButton: __assign(__assign(__assign(__assign({}, shorthands.gap('8px')), shorthands.padding('6px', '8px')), { marginRight: '4px', minWidth: '48px', maxWidth: '120px' }), shorthands.border('1px', tokens.colorNeutralStroke2)),
    meetingInsightsMenuItem: __assign({}, shorthands.padding('0px')),
    insightsOverflowButton: __assign(__assign({ minWidth: '42px', backgroundColor: 'transparent' }, shorthands.border('0px')), { ':hover': {
            backgroundColor: tokens.colorSubtleBackgroundLightAlphaHover,
        }, ':hover:active': {
            backgroundColor: tokens.colorSubtleBackgroundLightAlphaPressed,
        } }),
    insightsOverflowButtonLightMode: {
        color: '#444791',
        ':hover': {
            color: '#383966', //hardcoded Teams Brand 40 token color
        },
        ':active': {
            color: '#383966', //hardcoded Teams Brand 70 token color
        },
        ':hover :active': {
            color: '#383966', //hardcoded Teams Brand 70 token color
        },
    },
    insightsOverflowButtonDarkMode: {
        color: '#9299F7',
        ':hover': {
            color: '#5B5FC7', //hardcoded Teams Brand 90 token color
        },
        ':active': {
            color: ' #7579EB', //hardcoded Teams Brand 100 token color
        },
    },
    meetingInsightsOverflowItem: __assign(__assign({ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start' }, shorthands.gap('8px')), shorthands.padding('6px', '8px')),
    text: __assign(__assign({}, shorthands.overflow('hidden')), { textOverflow: 'ellipsis' }),
    truncateText: {
        whiteSpace: 'nowrap',
    },
    actionButton: {
        minWidth: '76px',
        cursor: 'pointer',
    },
    iconThumbnail: {
        height: '20px',
    },
    vivaIcon: {
        paddingBottom: '4px',
    },
    nameMargin: {
        marginLeft: '12px',
    },
    footer: __assign({ height: CardFooterHeight }, shorthands.margin('-4px', '0px', '0px')),
    insightDescriptionPrefix: {
        color: tokens.colorNeutralForeground1,
        fontWeight: tokens.fontWeightSemibold,
        marginRight: '8px',
    },
    insightDescription: __assign(__assign({ color: tokens.colorNeutralForeground2, marginTop: '12px' }, shorthands.overflow('hidden')), { display: '-webkit-box', WebkitBoxOrient: 'vertical', WebkitLineClamp: 3 }),
    badge: {
        bottom: '-2px',
        right: '-6px',
        color: tokens.colorNeutralForeground1,
    },
    activityIcon: {
        marginLeft: '4px',
    },
    taskActivityDescriptionMargin: {
        marginLeft: '8px',
    },
    cardPreviewIcon: {
        width: '24px',
        height: '24px',
        viewBox: '0 7 21 10',
        fill: 'none',
    },
});
//# sourceMappingURL=RecommendedCardControl.styles.js.map